import "./Seo.module.css";
import Header from "@/reusable_sections/Header";
import HeroSeoOverview from "./sections/HeroSeoOverview";
import Visibility from "./sections/Visibility";
import AgencyBenefits from "./sections/AgencyBenefits";
import WhyChooseAsahi from "./sections/WhyChooseAsahi";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import ReadyToBoostYourRankings from "./sections/ReadyToBoostYourRankings";
import Footer from "@/reusable_sections/Footer";
import PricingCopy from "./sections/PricingCopy";
export default function SeoPage() {
  return <div>
      <Header />
      <HeroSeoOverview />
      <Visibility />
      <AgencyBenefits />
      <WhyChooseAsahi />
      <PricingCopy />
      <FrequentlyAskedQuestions />
      <ReadyToBoostYourRankings />
      <Footer />
    </div>;
}